import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import RtkBaseQueryWithReauth from './RtkBaseQueryWithReauth';
import ApiPath from "./ConstantApi";
import { CountryResponseModel, CountryItemModel, CountryNewResModel, CountryNewModel } from './../Helpers/Interfaces/SettingType';
import { setCountryDialingList } from '../Redux/Slices/SettingSlice';

export const CountryService = createApi({
  reducerPath: "CountryService",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ["Country"],
  endpoints: (builder) => ({
    // getCountryList: builder.query<CountryResponseModel, any>({
    //   query: () => ({
    //     url: `${ApiPath.getCountry}`,
    //     method: "GET",
    //   }),
    //   // transformResponse: (response: { data: CountryResponseModel }) => response.data,
    //   providesTags: ["Country"],
    // }),
    
    getAllCountry: builder.query({
      query: ({...patch }) => ({
        url: `${ApiPath.getAllCountry}`,
        method: 'POST',
        body: patch,
      }),
      providesTags: ["Country"],
    }),

  
    searchCountry: builder.query<any, string>({
      query: (searchString) => ({
        url: `${ApiPath.countrySearch}?name=${searchString}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: any }) => response?.data && Array.isArray(response?.data) ? response.data.map((country:any) => ({
        extraData: {
          dialingCode: country.dailCode,
          flag: country.flags?.svg,
          currencies: country.currencies,
        },
        label: country.CountryName,
        value: country.CountryIso,
      })) : [],
    }),

    updateCountry: builder.mutation({
      query: ({ _id, ...patch }) => ({
        url: `${ApiPath.updateCountry}/${_id}`,
        method: 'PUT',
        body: patch,
      }),
      invalidatesTags: ["Country"],
    }),

    getCountryDialingList: builder.query<CountryNewModel[], void>({
      query: () => ({
        url: `${ApiPath.countryDialingInfoApi}`,
        method: "POST",
        body: {"filters": []},
      }),
      providesTags: ["Country"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data }: any = await queryFulfilled;
          const formattedOptions = data.data.map((country: any) => {
              const dialingCode = country.dailCode? `${country.dailCode}`: country.idd ? `${country.idd}`: "N/A";
              const currencies = country.currencies && country.currencies ? country.currencies : "";
              const flag=country.flags?.svg;
              return {
                label: `${country.CountryName}`,
                value: country.CountryIso,
                extraData: {dialingCode, flag,currencies, phoneRefil: country.phoneRefil, mobileLength: {min:country.phoneNumberLength?.Minimum, max:country.phoneNumberLength?.Maximum}}
              };
            })
            .sort((a: { label: string }, b: { label: string }) =>
              a.label.localeCompare(b.label)
            );
          dispatch(setCountryDialingList({ countryDialingList: formattedOptions }));
        } catch (error) {
        }
      },
    }),
  }),
});

export const { useLazyGetAllCountryQuery, useUpdateCountryMutation, useLazyGetCountryDialingListQuery, useLazySearchCountryQuery } = CountryService;